import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
export type FullDimensionName = (typeof apiSlugToDimensionName)[DimensionSlug];

// TODO: check that dimension slugs is the same for cpg and visitation
export const dimensionSlugs = [
  'iol',
  'ds',
  'aud',
  'inv_type',
  'plcmnt',
  'typ',
  'agency',
  'brand',
  'ad',
  'site',
  'channel',
  'publisher',
  'creative',
  'ad_frequency',
  'visit_frequency',
] as const satisfies readonly DimensionSlug[];

export type DimensionSlug = keyof typeof apiSlugToDimensionName;

export const validDimensionSlug = (slug: string): slug is DimensionSlug =>
  slug in apiSlugToDimensionName;

export const convertSlugToDimensionName = (
  slug: DimensionSlug
): FullDimensionName => apiSlugToDimensionName[slug];

export type SubdimensionCounts = Partial<Record<DimensionSlug, number>>;

export const buildDimensionCounts = (
  subdimensions: { dimensionName: string }[]
) => {
  return subdimensions.reduce(
    (acc, subdimension) => {
      const dimension = subdimension.dimensionName;
      if (!validDimensionSlug(dimension)) return acc;

      const currentCount = acc[dimension] ?? 0;
      return {
        ...acc,
        [dimension]: currentCount + 1,
      };
    },
    {} as Record<DimensionSlug, number>
  );
};
